import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { GoogleMap, LoadScript, MarkerF } from '@react-google-maps/api';
import './FarmerInfoPage.css';


const FarmerInfoPage = () => {
  const [farmer, setFarmer] = useState({});
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    const fetchFarmerData = async () => {
      try {
        const res = await axios.get(`https://krimaanapp-4.onrender.com/api/farmer/${id}`);
        setFarmer(res.data);
      } catch (err) {
        console.error('Error fetching farmer data', err);
      }
    };
    fetchFarmerData();
  }, [id]);

  // useEffect Hooks is used to identify the side effect of Each farmer's Id to get the correct information from MongoDB database


  const handleCropRecommendation = () => {
    navigate(`/cropRecommendation/${id}`);
  };



  return (
    <div data-aos ='fade-up' data-aos-duration='1000' className="farmer-info-page">
      <h1 className='farmer-info-heading'>Farmer's Information</h1>
      <button className="logout-button" onClick={() => navigate('/login')}>Logout</button>

      <div className="farmer-details" data-aos='fade-right' data-aos-duration= '1000'>

        <h2 className='soil_card_info_heading'>Soil Card Information</h2>
        <div className='line_first'></div>
        <p>Name: {farmer.name || 'Not Found'}</p>
        <p>ID: {farmer.id || 'Not Found'}</p>
        <p>Field Size: {farmer.fieldSize ||'Not Found'} Hector</p>
        <p>Address: {farmer.address || 'Not Found'}</p>
        <p>Crop: {farmer.crop || 'Not Found'}</p>
        <p>Nitrogen:  {farmer.nitrogen|| 'Not Found'}</p>
        <p>Phosphorus:  {farmer.phosphorus|| 'Not Found'}</p>
        <p>Potassium:  {farmer.potassium|| 'Not Found'}</p>
        <p>pH:  {farmer.ph|| 'Not Found'}</p>
        <p>Temperature:  {farmer.temperature|| 'Not Found'}</p>
        <p>Humidity:  {farmer.humidity|| 'Not Found'}</p>
        <p>Rainfall:  {farmer.rainfall|| 'Not Found'}</p>
        <p>Location: Lat: {farmer.location?.lat || 'Not Found'}, Lng: {farmer.location?.lng || 'Not Found'}</p>
      </div>

   {/* Farmer Location starts Gmap Position  */}

      <div className="farmer-location" data-aos = 'fade-left' data-aos-duration= '1000'>
        <h2 className ='farmer_location_heading'>Farmer's Location</h2>
        {farmer.location?.lat && farmer.location?.lng ? (
          <LoadScript googleMapsApiKey="AIzaSyD5fpQtJiWG8MUYTFPHkuwhS9MaRYxhTjc">
            <GoogleMap
              mapContainerStyle={{ height: '450px', width: '900px' }}
              center={{ lat: farmer.location.lat, lng: farmer.location.lng }}
              zoom={15}
            >
              <MarkerF position={{ lat: farmer.location.lat, lng: farmer.location.lng }} />
            </GoogleMap>
          </LoadScript>
        ) : (
          <p>Lat: Not Found, Lng: Not Found</p>
        )}
      </div>

  {/* Gmap Location for the farmers ends  */}



   {/* section for  weather information starts     */}
<div className='section_for_weather_information'>
 <h1 className = 'weather_information'>Weather Information</h1>
 <div className='weather_information_box'>
   <div className ='August_weather'>
    <h1>August</h1>
    <p>{farmer.weather_1 || 'Not Found'}</p>
    <p>{farmer.weather_1_ || 'Not Found'}</p>
    <p>{farmer.weather_1_first || 'Not Found'}</p>

    <div className='line'></div>
   </div>
   <div className ='September_weather'>
    <h1>September</h1>

    <p>{farmer.weather_2 || 'Not Found'}</p>
    <p>{farmer.weather_2_ || 'Not Found'}</p>
    <p>{farmer.weather_2_second || 'Not Found'}</p>

    <div className='line'></div>
   </div>
   <div className ='October_weather'>
    <h1>October</h1>
    <p>{farmer.weather_3 || 'Not Found'}</p>
    <p>{farmer.weather_3_ || 'Not Found'}</p>
    <p>{farmer.weather_3_third || 'Not Found'}</p>

    <div className='line'></div>
   </div>
 </div>
</div>
 {/* section for weather information ends */}


 {/* Trending crops for the market section starts  */}

<div className ='Market_information'>
  <h1 className = 'market_information_heading'>Market Information</h1>
  <div className = 'big_underline'></div>

  <div className ='market_trending_container_box'>
    <h1 className='trending_crops'>Trending Crops in your area</h1>



  <div className ='crop_name_and_button'>

    <p>{farmer.trending_crops_1 || 'Not Found'}
      <div className ='each_button'>
       <button>Get Directions</button>
      </div>
       </p>
    <p>{farmer.trending_crops_2 || 'Not Found'}

    <div className ='each_button'>
       <button>Get Directions</button>
      </div>
      </p>
    <p>{farmer.trending_crops_3 || 'Not Found'}
    <div className ='each_button'>
       <button>Get Directions</button>
      </div>
      </p>
  </div>
  </div>
  <div className='crop_recommendation_button'>
    <button onClick= {handleCropRecommendation}>Crop Recommendation</button>
  </div>
</div>

 {/* Trending Crops In the  Market Information Ends  */}

 </div>


  );
};

export default FarmerInfoPage;
// default crops at the same page

// working ever the distance
// trending over the crops for the next section which will be derived from the second agenda

//